import { Box, IconButton, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
//import { resetPassword } from 'src/services/registeration/registerationService';
import { useSearchParams } from 'react-router';
import toast from 'react-hot-toast';
import { resetPassword } from 'src/services/registeration/registerationService';
import { useNavigate } from 'react-router';
import { Filter } from 'bad-words';
import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
const filter = new Filter();

const schema = yup.object().shape({
    newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character').test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm your password').test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
});


export default function ResetPassword() {
  const { control, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [searchParams] = useSearchParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate(); 
  const token = searchParams.get('token');

  const onSubmit = async (data: any) => {
    const response = await resetPassword(token!, data.newPassword);
    if (response.ok) {
      toast.success('Password successfully reset!');
      setTimeout(() => {
        navigate('/login'); 
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Box width="100%" maxWidth="400px" p={4} boxShadow={2} bgcolor="white" borderRadius={2}>
        <Typography variant="h6" mb={2}>Set New Password</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
         <Controller
  name="newPassword"
  control={control}
  render={({ field, fieldState }) => (
    <TextField
      {...field}
      label="New Password"
      type={showNewPassword ? 'text' : 'password'}
      fullWidth
      margin="normal"
      slotProps={{
        input: {
          sx: { bgcolor: 'white' },
          endAdornment: (
            <IconButton onClick={() => setShowNewPassword((prev) => !prev)}>
              {showNewPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        },
        htmlInput: {
          sx: { textIndent: 10 },
        },
      }}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
    />
  )}
/>

        <Controller
  name="confirmPassword"
  control={control}
  render={({ field, fieldState }) => (
    <TextField
      {...field}
      label="Confirm Password"
      type={showConfirmPassword ? 'text' : 'password'}
      fullWidth
      margin="normal"
      slotProps={{
        input: {
          sx: { bgcolor: 'white' },
          endAdornment: (
            <IconButton onClick={() => setShowConfirmPassword((prev) => !prev)}>
              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        },
        htmlInput: {
          sx: { textIndent: 10 },
        },
      }}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
    />
  )}
/>

          <LoadingButton type="submit" variant="contained" fullWidth loading={isSubmitting}>
            Reset Password
          </LoadingButton>
        </form>
      </Box>
    </Box>
  );
}